const defaultTextValues = {
  title: {
    en: 'Form'
  },
  thankYou: {
    en: 'Thank you!'
  }
};

export default defaultTextValues;
